<template>
  <div class="vd-HorizontalTile_Wrapper">
    <div class="row position-relative">
      <div
        :class="{ 'col-sm-16': image }"
        class="d-flex align-items center-justify-content-start position-static"
      >
        <div class="p-3 my-auto">
          <div class="mb-2">
            <p class="h4">
              <a :href="link" class="stretched-link text-dark">{{ name }}</a>
            </p>
          </div>
          <p v-if="description" class="mb-0 text-sm text-muted">{{ description }}</p>
          <div v-if="categories || address" class="mt-2">
            <Attribute v-if="categories" :value="categories" icon="icon-tag" />
            <Attribute v-if="address" :value="address" icon="icon-pin-sm" />
          </div>
          <div v-if="badges.length" class="mt-2">
            <BadgeGroup>
              <Badge
                v-for="(badge, index) in badges"
                :key="index"
                :text="badge.text"
                :variant="badge.variant"
              ></Badge>
            </BadgeGroup>
          </div>
          <div v-if="productLink || link" class="flex-grow-1 mt-3 d-flex align-items-end">
            <div class="mt-n1 ml-n1 d-flex flex-wrap">
              <ActionButton
                v-if="link"
                :href="link.url"
                variant="small"
                class="mt-1 ml-1 stretched-link"
              >
                {{ link.text }}
              </ActionButton>
              <ActionButton
                v-if="productLink"
                :href="productLink.url"
                variant="small"
                class="mt-1 ml-1 position-relative z-1"
              >
                {{ productLink.text }}
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
      <div v-if="image" class="col-sm-8">
        <div class="p-3 pl-sm-0">
          <img
            :src="image"
            :alt="name"
            class="rounded img-fluid w-100"
            loading="lazy"
            width="525"
            height="370"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "./ActionButton.vue";
import Attribute from "./Attribute.vue";
import Badge from "./Badge.vue";
import BadgeGroup from "./BadgeGroup.vue";

export default {
  name: "VendorTile",
  components: {
    ActionButton,
    Attribute,
    Badge,
    BadgeGroup,
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: String,
      default: "",
    },
    link: {
      type: Object,
      default: () => {},
    },
    productLink: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
